import backend from '@common/backend';

const BASE = '/groups';

export interface IGetGroupsQuery {
	service_id?: string | number;
	search?: string;
	page?: number;
	limit?: number;
	location_id?: any;
	fields?: string[];
}

export const groupFromBE = (group: any) =>
	group
		? {
				// @TODO: Remove when BE will be fixed
				...group,
				service: group.service_template?.service_id || undefined,
				service_template: group.service_template?.id || undefined,
				service_name: group.service_template?.name || undefined,
				cgCoordinators:
					group.cgCoordinators ||
					group.cgCoorditators ||
					group.cg_coordinators ||
					group.c_g_coordinators ||
					[],
			}
		: group;

const groupToBE = ({
	location,
	service,
	service_template,
	mentor_id,
	timezone,
	cgCoordinators: _cgCoordinators,
	cgCoorditators: _cgCoorditators,
	isCgService: _isCgService,
	...group
}: any) => ({
	// @TODO: Remove when BE will be fixed
	...group,
	location_id: location?.id || null,
	service_id: service,
	service_template_id: service_template,
	mentor_id: mentor_id?.user_id ? mentor_id.user_id : mentor_id,
	timezone_id: timezone?.id || group.timezone_id,
});

export const getGroups = async (query: IGetGroupsQuery) =>
	backend
		.get(`${BASE}/`, {
			params: query,
		})
		.then((groups: any) => groups.map(groupFromBE));

export const getGroupList = async (query: IGetGroupsQuery) =>
	backend
		.get(`${BASE}/list`, {
			params: query,
		})
		.then((groups: any) => groups.map(groupFromBE));

export const postGroup = async (data: any) => backend.post(`${BASE}`, data);

export const getGroup = async (id: number) => backend.get(`${BASE}/${id}`).then(groupFromBE); // @TODO: Remove when BE fixed

export const getCgCoordinatorsGroup = async (id: number) =>
	backend
		.get(`${BASE}/${id}/cgCoordinators`)
		.then((response: any) => response?.data || response || []);

export const saveGroup = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, groupToBE(data)).then(groupFromBE);

export const deleteGroup = async (id: number) => backend.delete(`${BASE}/${id}`);

export const deleteCgCoordinatorGroup = async (id: number) =>
	backend.delete(`${BASE}/${id}/cgCoordinators`);

export const addStudentsToGroup = async (id: number, data: any) =>
	backend.patch(`${BASE}/${id}/students`, data);

export const addCgCoordinatorsToGroup = async (id: number, data: any) =>
	backend.patch(`${BASE}/${id}/cgCoordinators`, data);

export const getGroupsCustomFields = async (query: IGetGroupsQuery) =>
	backend
		.get(`${BASE}/customFields`, {
			params: query,
		})
		.then((groups: any) => groups.map(groupFromBE));

export const deleteStudentFromGroup = async (studentId: number, data: any) =>
	backend.delete(`${BASE}/${studentId}/students`, data);

export const deleteCgCoordinatorsFromGroup = async (studentId: number, data: any) =>
	backend.delete(`${BASE}/${studentId}/cgCoordinators`, data);

export const getGroupAddresses = async () => backend.get('/groupAddresses');
